export const commissionStatemnetsTableHeadingsData = [
  "Date",
  "Statement",
  "Commission Amount",
  "Status",
];
export const comissionStatementsData = [
  {
    commissionDate: "05 Oct‘24",
    commissionStatemnet: "October Statement",
    commissionAmount: "$1,321",
    commissionStatus: "Pending",
  },
  {
    commissionDate: "05 Sep‘24",
    commissionStatemnet: "September Statement",
    commissionAmount: "$1,287",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 Aug‘24",
    commissionStatemnet: "August Statement",
    commissionAmount: "$1,412",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 July‘24",
    commissionStatemnet: "July Statement",
    commissionAmount: "$1,521",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 June‘24",
    commissionStatemnet: "June Statement",
    commissionAmount: "$1,365",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 May‘24",
    commissionStatemnet: "May Statement",
    commissionAmount: "$1,276",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 April‘24",
    commissionStatemnet: "April Statement",
    commissionAmount: "$1,198",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 March‘24",
    commissionStatemnet: "March Statement",
    commissionAmount: "$1,564",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 Feb‘24",
    commissionStatemnet: "February Statement",
    commissionAmount: "$1,476",
    commissionStatus: "Paid",
  },
  {
    commissionDate: "05 Jan‘24",
    commissionStatemnet: "January Statement",
    commissionAmount: "$1,654",
    commissionStatus: "Paid",
  },
  // {
  //   commissionDate: "05 Aug ‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Pending",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Pending",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
  // {
  //   commissionDate: "05 Aug‘24",
  //   commissionStatemnet: "August Statement",
  //   commissionAmount: "$16,656",
  //   commissionStatus: "Paid",
  // },
];
